import { ErrorBox } from "@whatslly/ui-components/ErrorBox";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./crm-components-error-box.module.scss";

export const CrmComponentsErrorBox: React.FC<{ error: string; testId?: string }> = ({ error, testId }) => {
  const { t } = useTranslation();

  const errorMessage = useMemo(() => {
    if (typeof error === "string" && error.includes("ONLY_TUVIS_ADMIN_OR_SYSTEM_ADMIN")) {
      return t("admin_or_sys_admin_only");
    }

    if (typeof error === "string" && error.includes("ONLY_TUVIS_ADMIN")) {
      return t("admin_only");
    }

    if (typeof error === "string" && error.includes("MISSING_TEMPLATE_TUVIS_CUSTOM_PERMISSION")) {
      return t("missing_template_tuvis_custom_permission");
    }

    return error;
  }, [error, t]);

  const tryAgain = useMemo(() => {
    return ["ONLY_TUVIS_ADMIN", "ONLY_TUVIS_ADMIN_OR_SYSTEM_ADMIN", "MISSING_TEMPLATE_TUVIS_CUSTOM_PERMISSION"].some(
      (item) => typeof error === "string" && error.includes(item)
    ) ? (
      <></>
    ) : undefined;
  }, [error]);

  if (typeof error === "string" && error.includes("UNAUTHORIZED_REMOTE_SITE")) {
    return (
      <div data-testid={testId} className={styles.remoteSettingsErrorWrapper}>
        <div className={styles.header}>Please Activate Remote Site Settings</div>
        <div>To add a activate remote site setting:</div>
        <div className={styles.points}>
          <div>
            1. In Salesforce, navigate to Setup, enter Remote Site Settings in the Quick Find box, then select <b>Remote Site Settings</b>.
          </div>
          <div>2. Locate all the Tuvis Remote Sites (Namespace Prefix is whatslly), and activate them:</div>
          <div>
            3. Click <b>Edit</b>
          </div>
          <div>
            4. Enable the <b>Active</b> checkbox
          </div>
          <div>
            5. Click <b>Save</b>.
          </div>
        </div>
        <div>
          Read More:{" "}
          <a target="_blank" href="https://help.salesforce.com/articleView?id=sf.configuring_remoteproxy.htm&type=5">
            Configure Remote Site Settings
          </a>
        </div>
        <a target="_blank" href="mailto:support@tuvis.com?subject=Tuvis+Support+Request">
          Need Help?
        </a>
      </div>
    );
  }

  return <ErrorBox error={errorMessage} tryAgain={tryAgain} testId={testId} />;
};
